import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import { HTML_ATTRIBUTE_COOKIE_IDS, HTML_ATTRIBUTE_BLOCKER_ID, HTML_ATTRIBUTE_BY, HTML_TAG_CONSENT_SCRIPT } from "../dom";
import { decideToUnblock } from ".";

/**
 * Read all HTML elements and check, if they can be enabled by a consent.
 */
function findBlockedNodes(checker) {
  var result = [];
  var nodes = Array.prototype.slice.call(document.querySelectorAll("[".concat(HTML_ATTRIBUTE_COOKIE_IDS, "]")));

  var _iterator = _createForOfIteratorHelper(nodes),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var node = _step.value;

      var _decideToUnblock = decideToUnblock(node.getAttribute(HTML_ATTRIBUTE_BY), node.getAttribute(HTML_ATTRIBUTE_COOKIE_IDS), +node.getAttribute(HTML_ATTRIBUTE_BLOCKER_ID), checker),
          blocker = _decideToUnblock.blocker,
          consent = _decideToUnblock.consent;

      var isVisualCb = node.className.indexOf("rcb-content-blocker") > -1;
      result.push({
        node: node,
        consent: consent,
        isVisualCb: isVisualCb,
        blocker: blocker,
        priority: node.tagName.toLowerCase() === HTML_TAG_CONSENT_SCRIPT ? 10 : 0
      });
    } // Sort blockable nodes by priority, e.g. always execute scripts at the end

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  result.sort(function (_ref, _ref2) {
    var a = _ref.priority;
    var b = _ref2.priority;
    return a - b;
  });
  return result;
}

export { findBlockedNodes };